<template xmlns="http://www.w3.org/1999/html">
  <el-dialog
    title="打印预览"
    :visible="visible"
    width="900px"
    :before-close="hideDialog"
    :close-on-click-modal="false"
  >
    <div id="ApproveAndSignPrint">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContract"
        style="margin: 10px 0"
        >打印
      </el-button>
      <div
        ref="bidFilePrint"
        id="bidFilePrint"
        style="font-size: 16px; font-family: 宋体"
      >
        <div style="text-align: center; font-size: 30px; padding: 30px 0 20px">
          {{ printData.title }}
        </div>
        <div style="text-align: center; font-size: 20px"></div>
        <div style="font-size: 18px; padding-bottom: 10px">
          <div
            contenteditable="true"
            style="display: inline-block; float: right"
          >
            时间：{{ formatDate(formData.approveTime) }}
          </div>
        </div>
        <div style="border: 1px solid rgb(0, 0, 0, 0.6); margin: 20px 0">
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 56px;
            "
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              提报单位
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.commitDeptName }}
            </div>
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                border-left: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              项目名称
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.projectName }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 56px;
            "
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              提报单位负责人
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.commitResponseUserName }}
            </div>
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                border-left: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              经办人
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.handlingUserName }}
            </div>
          </div>

          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              min-height: 460px;
              padding: 4px;
            "
          >
            <div>项目情况：</div>
            <div style="margin: 20px; text-indent: 20px">
              {{ formData.projectState }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              min-height: 280px;
              page-break-inside: avoid;
              padding: 4px;
            "
          >
            <div>招标办意见（同意、附条件同意或不同意）：</div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
            >
              <div
                v-for="(item, index) in formData.filterApproveInfoList"
                :key="index"
                style="
                  margin: 20px 40px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div v-if="item.opinion">{{ item.opinion }}。</div>
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="100px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="printWrap" v-show="false">
        <div
          v-html="bidFileContent"
          class="mainHtml"
          id="printbidFileContent"
        ></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import printJS from "print-js";

export default {
  name: "ApproveAndSignPrint",
  props: {
    printData: {
      type: Object,
    },
    visible: {
      type: Boolean,
      defaule: false,
    },
  },
  data() {
    return {
      approveProcessList: [],
      bidFileContent: null,
    };
  },
  computed: {
    formData() {
      const filterApproveInfoList = this.printData.approveInfoList.filter(
        (i) => i.isPrint
      );
      return {
        ...this.printData,
        filterApproveInfoList,
      };
    },
  },

  mounted() {
    //     try{
    // this.bidFileContent = this.$refs.bidFilePrint.innerHTML;
    //     this.bidFileContent =
    //       document.getElementById("bidFilePrint").innerHTML;
    //     }catch(err){
    //       console.log(err)
    //     }
  },
  methods: {
    hideDialog() {
      this.$emit("update:visible", false);
    },
    //打印当前合同
    PrintContract() {
      this.$set(this, "bidFileContent", this.$refs.bidFilePrint.innerHTML);
      this.$nextTick(() => {
        printJS({
          printable: "printbidFileContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
        });
      });
    },
    formatDate(dateStr) {
      let date = new Date(dateStr);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      return `${year}年${month}月${day}日`;
    },
  },
};
</script>
<style lang="scss">
#bidFilePrint {
  box-shadow: 0px 4px 12px 2px #bbb;
  position: relative;
  padding: 0 10px;
  width: 21cm;
  margin: 0 auto;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
